import React, { useState, useEffect } from 'react';

import { FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import { useDispatch } from 'react-redux';

import { setProfil, setCondition } from 'handimap-react-lib/store/actions/profilActions';
import { profilMapping } from '../utils/profilConverter';


export const ProfilChoices = () => {
  const [value, setValue] = useState('');
  const dispatch = useDispatch();

  useEffect(() => {
  }, []);

  const handleChange = (event) => {
    const key = event.target.value;
    setValue(key);
    dispatch(setProfil(key));
    dispatch(setCondition(Object.keys(profilMapping[key])[0]))
  };

  return (
    
    <FormControl size="small">
      <InputLabel 
        color='primary'
        id="zoom-control-select-label"
      >
        Profil
      </InputLabel>
      <Select
        labelId="zoom-control-select-label"
        id="zoom-control-select"
        label='Profil'
        value={value}
        onChange={handleChange}
        onBlur={() => setValue('')}
        color='primary'
        variant='outlined'
        size="small"
        sx={{
          backgroundColor: 'white',
          borderRadius: '0.5em',
          width: '6em',
          height: '2.5em'
        }}
        displayEmpty
        MenuProps={{
          PaperProps: {
            sx: {
              '& .MuiMenuItem-root': {
                color: 'primary.main',
              },
            },
          },
        }}
      >
        <MenuItem key='Marche' value='Marche'>Marche</MenuItem>
        <MenuItem key='Déficience visuelle' value='Déficience visuelle'>Déficience visuelle</MenuItem>
        <MenuItem key='Déficience motrice' value='Déficience motrice'>Déficience motrice</MenuItem>
        <MenuItem key='Déficience auditive' value='Déficience auditive'>Déficience auditive</MenuItem>
        <MenuItem key='Déficience mentale' value='Déficience mentale'>Déficience mentale</MenuItem>
      </Select>
    </FormControl>
  );
};